/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Modify_Clock_Times_HelpInputs */



/**
* | output |
* | --- |
* | "The timing will be adjusted based on the difference between the source and target Frame Rates" |
*
* @param {Modify_Clock_Times_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const modify_clock_times_help = /** @type {((inputs?: Modify_Clock_Times_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Modify_Clock_Times_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le minutage sera ajusté selon la différence entre les fréquences d’images source et cible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Zeitsteuerung wird anhand der Differenz zwischen Quell- und Zielbildrate angepasst.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La temporizzazione verrà regolata in base alla differenza tra i frame rate di origine e di destinazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Время будет скорректировано в зависимости от разницы между исходной и целевой частотой кадров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El tiempo se ajustará en función de la diferencia entre las velocidades de fotogramas de origen y destino.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间调整将根据源帧速率和目标帧速率之间的差异进行。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイミングはソースとターゲットのフレームレートの差に基づいて調整されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत और लक्ष्य फ्रेम दरों के बीच के अंतर के आधार पर समय को समायोजित किया जाएगा।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O tempo será ajustado com base na diferença entre as taxas de quadros de origem e de destino.")
	return /** @type {LocalizedString} */ ("The timing will be adjusted based on the difference between the source and target Frame Rates")
});